/* eslint-disable no-mixed-operators */

export const validationCPF = (value: string) => {
    const cpf = value.replace(/\D/g, '')
    if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false
    const numbers = cpf.split('').map((el: string) => +el)
    const rest = (count: number): number =>
        ((numbers
            .slice(0, count - 12)
            .reduce(
                (soma: number, el: number, index: number) =>
                    soma + el * (count - index),
                0
            ) *
            10) %
            11) %
        10
    return rest(10) === numbers[9] && rest(11) === numbers[10] ? true : false
}

export function validationCNPJ(cnpj: string): boolean {
    const cleanedCnpj = cnpj.replace(/\D/g, '')

    if (cleanedCnpj.length !== 14) {
        return false
    }

    if (/^(\d)\1+$/.test(cleanedCnpj)) {
        return false
    }

    const multiply = (multipliers: number[], digits: number[]) => {
        let sum = 0
        for (let i = 0; i < multipliers.length; i++) {
            sum += multipliers[i] * digits[i]
        }
        return sum
    }

    const mod = (num: number, base: number) => {
        return Math.abs(num - Math.floor(num / base) * base)
    }

    const multipliers1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
    const multipliers2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

    const digits = cleanedCnpj.split('').map(Number)

    const firstDigit =
        mod(multiply(multipliers1, digits), 11) < 2
            ? 0
            : 11 - mod(multiply(multipliers1, digits), 11)
    const secondDigit =
        mod(multiply(multipliers2, [...digits, firstDigit]), 11) < 2
            ? 0
            : 11 - mod(multiply(multipliers2, [...digits, firstDigit]), 11)

    return digits[12] === firstDigit && digits[13] === secondDigit
}
